import PropTypes from 'prop-types';

import ComparisonTableBody from './components/ComparisonTableBody';
import ComparisonTableHead from './components/ComparisonTableHead';
import WithScrollIntoViewButton from './components/WithScrollIntoViewButton';
import { FEATURES_TYPES } from './constants';
import { useFeatures } from './hooks/useFeatures';
import './ComparisonTable.scss';

const ComparisonTable = ({
  plans,
  featuresType,
  withScrollIntoViewButton,
  scrollIntoViewButtonLabel,
  hideSMSinfo,
  isAuCustomer = false,
  isGbCustomer = false,
  smsStartingPrice,
}) => {
  const processedFeatures = useFeatures({
    plans,
    featuresType,
    hideSMSinfo,
    isAuCustomer,
    isGbCustomer,
    smsStartingPrice,
  });

  const comparisonTableNode = (
    <div className="comparison-table">
      <table>
        <ComparisonTableHead plans={plans} />
        <ComparisonTableBody
          planFeatures={processedFeatures}
          plans={plans}
          recommendedPlanNameId={plans.find((plan) => plan.isRecommended)?.planNameId}
        />
      </table>
    </div>
  );

  if (withScrollIntoViewButton) {
    return (
      <WithScrollIntoViewButton scrollIntoViewButtonLabel={scrollIntoViewButtonLabel}>
        {comparisonTableNode}
      </WithScrollIntoViewButton>
    );
  }

  return comparisonTableNode;
};

ComparisonTable.propTypes = {
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      planId: PropTypes.number.isRequired,
      planNameId: PropTypes.string.isRequired,
      planNameLabel: PropTypes.string.isRequired,
      isSelected: PropTypes.bool.isRequired,
      isRecommended: PropTypes.bool.isRequired,
      isCurrent: PropTypes.bool.isRequired,
      price: PropTypes.shape({
        paymentPeriodLabel: PropTypes.string.isRequired,
        planCurrency: PropTypes.string.isRequired,
        planFullPrice: PropTypes.number.isRequired,
        planPriceDiscounted: PropTypes.number,
        isUpdatingCurrency: PropTypes.bool.isRequired,
        showDecimals: PropTypes.bool.isRequired,
      }),
      buttonLabel: PropTypes.string.isRequired,
      buttonClickHandler: PropTypes.func.isRequired,
      buttonDisabled: PropTypes.bool.isRequired,
      buttonHidden: PropTypes.bool.isRequired,
    })
  ).isRequired,
  featuresType: PropTypes.oneOf([FEATURES_TYPES.V21, FEATURES_TYPES.LEGACY]).isRequired,
  withScrollIntoViewButton: PropTypes.bool,
  scrollIntoViewButtonLabel: PropTypes.string,
  hideSMSinfo: PropTypes.bool,
  isAuCustomer: PropTypes.bool,
  isGbCustomer: PropTypes.bool,
  smsStartingPrice: PropTypes.number,
};

ComparisonTable.defaultProps = {
  withScrollIntoViewButton: false,
  scrollIntoViewButtonLabel: '',
};

export default ComparisonTable;
